module.exports = __webpack_public_path__ + "static/media/IE.bab19d45.png";